<template>
    <div class="client-select">
        <Select
            class="client-select-inner"
            data-testid="clients-list__select"
            v-bind="$attrs"
            @onChange="$attrs.onChange"
        >
            <Option
                v-for="client in options"
                :key="client._id"
                class="client-select-option"
                :value="client._id"
                :title="client.name"
            >
                {{ client.name }}
            </Option>
        </Select>
    </div>
</template>

<script lang="ts">
import bus from "@/bus";

import ClientsQuery from "@/apollo/queries/Clients.gql";
import type { PropType } from "vue";
import type { Client } from "hoxton-types";

export default {
    name: "ClientSelect",

    props: {
        excludedIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            clients: [] as Client[],
            isLoading: true
        };
    },

    computed: {
        options() {
            return this.clients.filter(
                client => client._id === this.$attrs.modelValue || !this.excludedIds.includes(client._id)
            );
        }
    },

    apollo: {
        clients: {
            query: ClientsQuery,
            variables() {
                return {
                    orderBy: "name_ASC",
                    wppProjectId: this.$store.state.auth?.wppProjectId
                };
            },
            error(e) {
                bus.$emit("apolloErrorEvent", e as Error);
            },
            result({ data: { clients } }) {
                this.isLoading = false;
                this.clients = clients;
            }
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.client-select {
    &-inner {
        .ivu-select-selection {
            right: 0;
        }

        &.ivu-select-visible {
            .ivu-select-selection {
                box-shadow: none;
            }
        }

        .ivu-select-selection {
            border: none;
            background-color: inherit;
            color: inherit;

            .ivu-select-placeholder {
                color: inherit;
            }
        }
    }
}
</style>
